import { ArrowRightIcon } from "lucide-react"
import Link from "next/link"
import { Button } from "@/components/ui/button"

export function AccountPlaceholderPage({
  description,
  title,
}: {
  description: string
  title: string
}) {
  return (
    <div className='rounded-2xl border bg-white p-6 shadow-xs md:p-8'>
      <div className='max-w-2xl space-y-4'>
        <div className='space-y-2'>
          <p className='font-medium text-muted-foreground text-sm uppercase tracking-[0.16em]'>
            Minha conta
          </p>
          <h1 className='font-semibold text-3xl text-foreground'>{title}</h1>
        </div>

        <p className='text-base text-muted-foreground leading-7'>
          {description}
        </p>

        <Button asChild variant='outline'>
          <Link href='/minha-conta'>
            Voltar para o painel
            <ArrowRightIcon aria-hidden='true' size={16} />
          </Link>
        </Button>
      </div>
    </div>
  )
}
